import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import ScrollIntoView from './ScrollIntoView';
import EditorViewer from './EditorViewer';
import { useNavigate } from 'react-router-dom';

const PREVIEW_STORAGE_PREFIX = "editPreviewDocData:";

const readPreviewData = () => {
    const previewId = new URLSearchParams(window.location.search).get("previewId");
    if (!previewId) return null;

    try {
        return JSON.parse(sessionStorage.getItem(`${PREVIEW_STORAGE_PREFIX}${previewId}`));
    } catch {
        return null;
    }
}

const Preview = (props) => {
    const LoginStates = useSelector((state) => state.login);
    const history = useNavigate();
    const [contentViewer, setContentViewer] = useState(null);
    const [rightContent, setRightContent] = useState(null);
    const [editorData, setEditorData] = useState(null);
    const [docId, setDocId] = useState("");
    const [docBoxPath, setDocBoxPath] = useState("");
    const prevEditorData = useRef(null);

    useEffect(() => {
        const root = document.getElementById('root');
        const prevMinWidth = root?.style.minWidth ?? "";
        if (root) {
            root.style.minWidth = 'unset';
        }

        const docData = readPreviewData();
        if (docData) {
            setEditorData(docData.editorData || {});
            setDocId(docData.docId || "");
            setDocBoxPath(docData.docBoxPath || "");
        } else {
            history('/');
        }

        return () => {
            if (root) {
                root.style.minWidth = prevMinWidth;
            }
        }
    }, [history]);

    useEffect(() => {
        if (editorData !== null) {
            setRightContent(<ScrollIntoView editorData={JSON.stringify(editorData)} manualId={""} docId={docId} devUserId={LoginStates.userId} fullPath={null} title={""} isPreview={true} />);
        } else {
            setRightContent(null);
        }
    }, [editorData, docId, LoginStates.userId]);

    useEffect(() => {
        if (!editorData || !docBoxPath) return;
        if (editorData !== prevEditorData.current) {
            prevEditorData.current = editorData;
            const folderName = docBoxPath;

            setContentViewer(
                <div className={"editor-section"}>
                    <div className={"title-section"}>
                        <p>{editorData?.title ?? ""}</p>
                    </div>
                    <EditorViewer docId={docId} folderName={folderName} editorData={editorData} />
                </div>
            );
        }
    }, [editorData, docBoxPath, docId]);

    const wrapStyle = {
        position: "relative",
        overflowY: "auto",
        display: "flex",
        padding: "50px 0 0 50px"
    }

    return (
        <div className='doc-type'>
            <div className='contents-wrap'>
                <div className="doc-wrap" style={wrapStyle}>
                    {contentViewer}
                    {rightContent}
                </div>
            </div>
        </div>
    )
}
export default Preview;
